import { getSetting } from 'local/lib/settings';
import { machine } from 'local/test/machine';
import Button from '@internetstiftelsen/styleguide/dist/atoms/button/Button';

const { i18n } = window.bredbandskollen;

function formatDate(timestamp) {
	const date = new Date(timestamp * 1000);

	return `${date.getDate()} ${i18n.months[date.getMonth()]} ${date.getFullYear()}, ${`0${date.getHours()}`.slice(-2)}:${`0${date.getMinutes()}`.slice(-2)}`;
}

class PreviousMeasures {
	constructor() {
		this.api = `https://${window.bredbandskollen.backend}/api/measurements`;
		this.container = document.getElementById('previousMeasurements');

		if (!this.container) {
			return;
		}

		this.content = document.getElementById('previousMeasurementsContent');
		this.template = document.getElementById('previousMeasurementsTemplate');
		this.templateFull = document.getElementById(
			'previousMeasurementsTemplateFull',
		);
		this.spinner = document.getElementById('previousMeasurementsSpinner');
		this.all = document.getElementById('previousMeasurementsAll');
		this.more = document.getElementById('previousMeasurementsMore');
		this.downloadBuilt = false;

		if (this.more) {
			this.more = new Button(this.more);
		}

		this.error = null;
		this.from = null;
		this.hashkey = getSetting('hash_key');
		this.type = this.container.getAttribute('data-type');
		this.limit = this.type === 'full' ? 10 : 3;

		if (this.container) {
			this.attach();
		}
	}

	attach() {
		machine.on('data', (data) => {
			if ('measurementInfo' in data) {
				this.from = null;
				this.fetch();
			}
		});

		if (this.more) {
			this.more.button.addEventListener('click', (e) => this.loadMore(e));
		}
	}

	loadMore(e) {
		e.preventDefault();

		this.more.start();
		this.fetch();
	}

	buildDownloadLinks() {
		if (this.downloadBuilt) {
			return;
		}

		const timezone = encodeURIComponent(Intl.DateTimeFormat().resolvedOptions().timeZone);
		const html = `<div class="display-flex justify-content-end align-items-center u-m-b-4">
	<a href="/stats/${this.hashkey}.csv?timezone=${timezone}" download class="u-link">${i18n.downloadCsv}</a>
	<a href="/stats/${this.hashkey}.json?timezone=${timezone}" download class="u-link u-m-l-2">${i18n.downloadJson}</a>
</div>`;

		const el = document.createRange().createContextualFragment(html);

		this.container.insertBefore(el, this.container.firstChild);
		this.downloadBuilt = true;
	}

	fetch() {
		if (!this.container || !this.hashkey) {
			return;
		}

		this.spinner.classList.remove('is-hidden');

		let url = `${this.api}?key=${this.hashkey}&max=${this.limit}`;

		if (this.from && this.type === 'full') {
			url += `&from=${this.from}`;
		}

		fetch(url, {
			headers: {
				Accept: 'application/json',
			},
		})
			.then((response) => response.json())
			.then((json) => this.previousMeasuresFetched(json))
			.catch((error) => this.previousMeasuresFailed(error))
			.finally(() => {
				this.spinner.classList.add('is-hidden');

				if (this.more) {
					this.more.stop();
				}
			});
	}

	renderMeasureData(measurement) {
		const html =
			this.type === 'full'
				? this.templateFull.innerHTML
				: this.template.innerHTML;
		const timestamp = formatDate(measurement.ts);
		const title =
			this.type === 'full'
				? `${timestamp} – ${measurement.server}`
				: timestamp;
		const download = `${measurement.down.toFixed(2)}`;
		const upload = `${measurement.up.toFixed(2)}`;
		const latency = `${measurement.latency.toFixed(2)}`;

		return document
			.createRange()
			.createContextualFragment(
				html
					.replace('{title}', title)
					.replace('{download}', download)
					.replace('{upload}', upload)
					.replace('{latency}', latency),
			);
	}

	toggleMore(json) {
		const remaining = json.remaining * 1;

		if (remaining) {
			this.more.button.classList.remove('is-hidden');
		} else {
			this.more.button.classList.add('is-hidden');
		}
	}

	previousMeasuresFetched(json) {
		if (typeof json !== 'object') {
			this.previousMeasuresFailed('Unexpected response');

			return;
		}

		const { measurements } = json;

		if (!measurements.length) {
			this.previousMeasuresNoHistory();

			return;
		}

		this.buildDownloadLinks();

		let id = null;

		if (this.type === 'summary' || !this.from) {
			this.content.innerHTML = '';
		}

		measurements.forEach((measurement) => {
			const el = this.renderMeasureData(measurement);

			this.content.appendChild(el);

			({ id } = measurement);
		});

		if (this.type === 'summary') {
			this.all.classList.remove('is-hidden');
		} else {
			this.toggleMore(json);
		}

		this.from = id;
	}

	previousMeasuresNoHistory() {
		if (this.from) {
			return;
		}

		this.content.innerHTML = `<div><em>${i18n.noPreviousMeasurements}</em></div>`;
	}

	previousMeasuresFailed(error) {
		console.error(error);

		if (this.from) {
			return;
		}

		this.content.innerHTML = `<div><em>${i18n.failedToFetchPreviousMeasurements}</em></div>`;
	}
}

export default new PreviousMeasures();
